import React from 'react';
import { FeathersContext } from './FeathersContext';
import useFeathersSocketIOClient from './hooks/useFeathersSocketIOClient';
import { SplashScreen } from '@strac/react-client-environment';

export function FeathersContextProvider(props: any) {
  const { children, socketUrl } = props;
  const feathersContext = useFeathersSocketIOClient(socketUrl);
  return (
    <>
      <SplashScreen visible={!feathersContext} />
      {feathersContext ? (
        <FeathersContext.Provider value={feathersContext}>
          {children}
        </FeathersContext.Provider>
      ) : null}
    </>
  );
}
